module.exports = __webpack_public_path__ + "static/img/repast02.19b84aa4.jpg";